import { render } from "./Landing.vue?vue&type=template&id=0987974f&scoped=true&bindings={\"shareModalActive\":\"data\",\"aboutModalActive\":\"data\",\"newSessionModalActive\":\"data\",\"generateRandomSessionId\":\"options\",\"createSession\":\"options\",\"about\":\"options\",\"share\":\"options\",\"closeShare\":\"options\",\"closeAbout\":\"options\",\"newSessionWarning\":\"options\",\"cancelNewSessionWarning\":\"options\"}"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=0987974f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0987974f"

export default script